import { useCallback, useState } from "react"
import dynamic from "next/dynamic"
import { PlaceRef } from "@/types/entity"
import { PlaceReview, PlaceType } from "@/types/place"

const LazyAddReviewDialog = dynamic(
  () =>
    import("@/components/dialog/add-review-dialog").then(
      (mod) => mod.AddReviewDialog
    ),
  { ssr: false }
)

interface OpenAddReviewDialogOptions {
  placeRef: PlaceRef
  placeType: PlaceType
  initialReview?: PlaceReview
  onClose?: () => void
}

export function useAddReviewDialog() {
  const [open, setOpen] = useState(false)
  const [dialogOptions, setDialogOptions] =
    useState<OpenAddReviewDialogOptions | null>(null)

  const openAddReviewDialog = useCallback(
    (options: OpenAddReviewDialogOptions) => {
      setDialogOptions(options)
      setOpen(true)
    },
    []
  )

  const closeAddReviewDialog = useCallback(() => {
    setOpen(false)
  }, [])

  const AddReviewDialog = dialogOptions ? (
    <LazyAddReviewDialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) {
          closeAddReviewDialog()
          dialogOptions.onClose?.()
        }
      }}
      placeRef={dialogOptions.placeRef}
      placeType={dialogOptions.placeType}
      initialReview={dialogOptions.initialReview}
    />
  ) : null

  return {
    isAddReviewDialogOpen: open,
    openAddReviewDialog,
    closeAddReviewDialog,
    AddReviewDialog,
  }
}
